import React, { useEffect, useState, useRef, useContext } from "react";
import Modal from "@components/modal";
import { Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import removeModalBackgroundScroll from "@utils/removeModalBackgroundScroll";
import ChevronDown from "@public/images/icons/chevron-down.svg";
import InfoIcon from "@public/images/icons/info-icon.svg";
import { InputSearch } from "@components/inputSearch";
import ChevronRight from "@public/images/icons/chevron-down.svg";
import NoResultsIcon from "@public/images/icons/not-found.svg";
import ArrowSvg from "@public/images/icons/arrow.svg";
import DOMPurify from "isomorphic-dompurify";
import {
  SAMPLE_POPULAR_VEHICLE_DATA,
  newMakeData,
  organizeCarsByMake
} from "@utils/organizeVehicleMakeModel";
import {
  MakeContainer,
  MakeTextContainer,
  MakeWrapper,
  ScrollBox,
  MakeImageContainer,
  MakeModelContainer,
  ModelTextContainer,
  ModelContainer,
  Seperator,
  FuelTypeContainer,
  FuelTypeItem,
  MmvInfoWrapper,
  InfotextContainer,
  StyledText,
  OptionsContainer,
  RadioIconContainer,
  NotFoundIconContainer,
  NotFoundWrapper,
  FindVehicleText,
  ReportNow,
  ModelWrapper,
  FuelTypeText,
  IconContainer
} from "./styles";
import ImageContainer from "@components/imageContainer";
import { SecondaryButton } from "@acko-tech/building-blocks.ui.button";
import {
  capitalizeFirstLetter,
  getDataFromStore,
  sampleAnalytics
} from "@utils/index";
import YearMonthSelector from "@components/mmvYearMonthSelector";
import { isArray, isObjectEmpty } from "@utils/lodash";
import useFuseSearch from "./useFuseSearch";
import MmvNotFoundModal, { FormatCTAtext } from "@components/mmvNotFoundModal";
import VariantNotFound from "@components/variantNotFound";
import StyledSelect from "@widgets/selectButton/styles";
import { Context } from "@components/useContext/context";
import { setPayloadData } from "@store/slices/globalState";
import { useDispatch, useSelector } from "react-redux";
import { getFirstVariantName, HighlightedHeading } from "./utils";
import { resolvePath } from "@utils/resolvePath";
import SkeletonCard from "@components/skeletonCard";
import { setAnalytics } from "@actions/setAnalyticsData";
import { useRunOnceHook } from "@components/common/custom-hooks";
import useRemoveModalBackgroundScroll from "@utils/removeModalBackgroundScroll";

const Content = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #5b5675;
  ${(props: { styles: any }) => props.styles}
  @media (min-width: 768px) {
    text-align: center;
  }
`;

const Title = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  color: #040222;
`;

// TODO: add props type
interface IMmvOptionsModal {
  showModal: boolean;
  setShowModal: (value: any) => void;
  queryType: string;
  handleClickedMake: (value: any) => void;
  handleClickedModel: (value: any) => void;
  handleClickedFuelType: (value: any) => void;
  handleClickedRegYear: (value: any) => void;
  handleClickedVariant: (value: any) => void;
  // todo: specify actual config, since this is used by many teams need to colab with diff teams for consistent defination
  config: any;
  currentId?: number;
}

interface IMMVInfoContent {
  infoText: string;
  shouldShowOptions: boolean;
  handleModalClick?: Function;
  query: string;
  styles?: any;
  firedOnce?: boolean;
}

interface NotFoundProps {
  handleClick: () => void;
  showNoResult?: any;
  query?: any;
  input?: string;
}

// todo: define types
const getInitialConfigStepIndex = (config: any, defaultStep: any) => {
  for (let i = 0; i < config.length; i++) {
    if (!config[i].selectedState || isObjectEmpty(config[i].selectedState)) {
      return i;
    }
  }
  return defaultStep;
};

const MmvInfoContent = ({
  infoText,
  shouldShowOptions,
  handleModalClick,
  query,
  styles,
  firedOnce
}: IMMVInfoContent) => {
  console.log("^^^^5", query);

  // todo: fix, i don't remember the problem why I used firedOnce :(
  if (query !== "is_commercial") {
    sampleAnalytics(
      "view",
      "view_modal",
      "view_modal_external_cng_kit_question_modal"
    );
  }
  if (shouldShowOptions) {
    useRunOnceHook({
      hookCondition: !firedOnce,
      callback: () => {
        console.log("^^^^5", firedOnce);
        sampleAnalytics(
          "view",
          "view_modal",
          query === "is_commercial"
            ? "view_modal_commercial_car_question_modal"
            : "view_modal_external_cng_kit_question_modal"
        );
        firedOnce = true;
      }
    });
  }

  return (
    <MmvInfoWrapper styles={styles} isVariantSheet={query === "variant"}>
      <InfotextContainer>
        <IconContainer>
          <InfoIcon height="75%" width="75%" />
        </IconContainer>
        <StyledText>{infoText}</StyledText>
      </InfotextContainer>
      {shouldShowOptions && (
        <OptionsContainer>
          <StyledSelect
            handleClick={() =>
              handleModalClick && handleModalClick("Yes", query)
            }
            styles={{ maxWidth: "107px", color: "#040222" }}
          >
            <FormatCTAtext>Yes</FormatCTAtext>
          </StyledSelect>
          <StyledSelect
            handleClick={() =>
              handleModalClick && handleModalClick("No", query)
            }
            styles={{ maxWidth: "107px", color: "#040222" }}
          >
            <FormatCTAtext>No</FormatCTAtext>
          </StyledSelect>
        </OptionsContainer>
      )}
    </MmvInfoWrapper>
  );
};

const NotFound: React.FC<NotFoundProps> = ({
  handleClick,
  showNoResult,
  query,
  input
}) => {
  if (showNoResult) {
    sampleAnalytics(
      "view",
      "view_modal",
      query !== "make"
        ? "view_modal_select_model_modal"
        : "view_modal_select_make_modal",
      {
        state: query !== "make" ? "cannot_find_model" : "cannot_find_make",
        search_keyword: input
      }
    );

    if(query === "make") {
      sampleAnalytics(
        "view",
        "view_modal",
        "view_page_car_not_found",
        {
          state: "cannot_find_make",
          search_term: input
        }
      );
    }
  }

  return (
    <>
      <NotFoundWrapper>
        <NotFoundIconContainer>
          <NoResultsIcon />
        </NotFoundIconContainer>
        <FindVehicleText>Unable to find your vehicle?</FindVehicleText>
        <ReportNow onClick={handleClick}>Report now</ReportNow>
      </NotFoundWrapper>
    </>
  );
};

const MmvOptionsModal: React.FC<IMmvOptionsModal> = ({
  showModal,
  setShowModal,
  queryType,
  handleClickedMake,
  handleClickedModel,
  handleClickedFuelType,
  handleClickedRegYear,
  handleClickedVariant,
  config,
  currentId = 0,
  ...props
}) => {
  console.log("sharedState init congid", config);
  const { isDesktop } = useContext(Context);

  const { hideCommercialField } = useSelector(
    ({ globalState }: any) => {
      return {
        hideCommercialField: globalState?.hideCommercialField
      };
    }
  )

  const [currentRenderedModal, setCurrentRenderedModal] = useState<any>("");
  // Since fueltype and variant are mapped togethter, thus using state to rerender once fueltype changes
  const [fuelType, setFuelType] = useState<any>();
  const [currentModalIndex, setCurrentModalIndex] = useState(currentId);
  const [showRegistrationYearModal, setShowRegistrationYearModal] =
    useState<boolean>(false);
  const [showNoResult, setShowNoResult] = useState<boolean>(false);
  const [showMmvNotFoundModal, setShowMmvNotFoundModal] =
    useState<boolean>(false);

  // input for fuzze searching and filtering
  const [input, setInput] = useState<string>("");
  const [currentModalData, setCurrentModalData] = useState<any>();
  const [fuseResult, setFuseResult] = useState<any>();

  const handleBackClickedRef = useRef(false);

  const handleSubmitNotFoundVehicle = () => {
    setInput("");
    setShowMmvNotFoundModal(false);
    // todo: confirmation with product abouht procedding with specific step ? XD
    setShowNoResult(false);
  };
  const goBack = () => {
    if (currentModalIndex > 0) {
      setInput("");
      handleBackClickedRef.current = true;
      setCurrentModalIndex(currentModalIndex - 1);
    }
  };

  const handleSegmentCallback = (query) => {
    sampleAnalytics(
      "action",
      "tap_btn",
      query === "make"
        ? "tap_btn_search_bar_select_make_modal"
        : "tap_btn_search_bar_select_model_modal"
    );
  };

  const handleNotFoundClick = () => {
    setShowMmvNotFoundModal(true);
  };

  const currentModal = config?.[currentModalIndex];
  let {
    id,
    isOptional,
    query,
    searchInputPlaceholder,
    showSearchInput,
    title,
    selectedState,
    setSelectedState,
    data
  } = currentModal || {};

  removeModalBackgroundScroll(showModal);
  // todo: Remove below code ONLY FOR DEMO PURPOSE

  // using fuse search :)
  const fuseResults = useFuseSearch(data, input, query);

  console.log("make data rerender", {
    currentModalData,
    fuseResults,
    input,
    data
  });

  useEffect(() => {
    console.log("^^^ 1", {
      currentModalData,
      input,
      showMmvNotFoundModal,
      fuseResults
    });
    if (input !== "") {
      if (!isObjectEmpty(fuseResults)) {
        setCurrentModalData(fuseResults);
        setShowNoResult(false);
      } else {
        setShowNoResult(true);
      }
    } else {
      setCurrentModalData(data);
      setShowNoResult(false);
    }
  }, [query, input, showMmvNotFoundModal, data]);

  useEffect(() => {
    if (query === "variant" && selectedState?.currentStateForFuelType) {
      setFuelType(selectedState?.currentStateForFuelType);
    }
  }, [query]);

  // todo: change it according to queryType
  const getMakeJsx = () => {
    if (!currentModalData) return;
    const dataToRender = input !== "" ? fuseResults : currentModalData;
    const getMakeContainerContent = () => {
      return dataToRender?.map((makeObject) => {
        const { make_name, logo_url } = makeObject;
        return (
          <MakeContainer
            selected={make_name === selectedState}
            onClick={(e: any) => handleModalClick(makeObject, "make")}
          >
            <MakeImageContainer selected={make_name === selectedState}>
              {/* Todo: use actual ImageContainer tag in Nextjs */}
              {/* @ts-ignore */}
              <div
                style={{
                  minHeight: "40px",
                  minWidth: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box"
                }}
              >
                <ImageContainer
                  imgSrc={logo_url}
                  quality={100}
                  objectFit="contain"
                />
              </div>
            </MakeImageContainer>
            <MakeTextContainer>{make_name}</MakeTextContainer>
          </MakeContainer>
        );
      });
    };
    return (
      <ScrollBox id="scrollbos">
        <MakeWrapper>{getMakeContainerContent()}</MakeWrapper>
      </ScrollBox>
    );
  };

  const getMakeModelJsx = () => {
    console.log("modelData", currentModalData);
    if (!currentModalData || !isArray(currentModalData)) return;
    const dataToRender = input !== "" ? fuseResults : currentModalData;
    console.log("^^^ make data render 9", {
      data,
      currentModalData,
      fuseResult,
      query,
      dataToRender
    });
    sampleAnalytics(
      "view",
      "view_modal",
      "view_modal_select_model_modal"
    );

    const getModelNames = () =>
      dataToRender?.map((modelObject: { model_name: any }, index: number) => {

        return (
          <>
            <ModelContainer
              onClick={() => handleModalClick(modelObject, "model")}
            >
              <Flex flexDirection="row" styles={{ position: "relative" }}>
                <ModelTextContainer
                  selected={modelObject?.model_name === selectedState}
                  key={index}
                >
                  {modelObject?.model_name}
                </ModelTextContainer>
                <RadioIconContainer>
                  <ImageContainer
                    imgSrc={resolvePath("/images/icons/chevron-down.svg")}
                    width={24}
                    height={24}
                    styles={{ rotate: "-90deg" }}
                  />
                </RadioIconContainer>
              </Flex>
            </ModelContainer>
            {index < Object.keys(dataToRender)?.length - 1 && <Seperator />}
          </>
        );
      });

    return (
      <ScrollBox>
        <MakeModelContainer>{getModelNames()}</MakeModelContainer>
      </ScrollBox>
    );
  };

  const getVariantsJsx = () => {
    console.log("variant data 11", data, fuelType, selectedState);
    if (query === "variant") {
      sampleAnalytics(
        "view",
        "view_modal",
        fuelType
          ? "view_modal_select_variant_modal"
          : "view_modal_select_fuel_type_modal"
      );
    }
    const varianttoRender = (fuelType: string | number) => {
      return data?.[fuelType];
    };
    const availableFuelTypes = Object.keys(data || {}).filter(
      (key) => data?.[key]?.length > 0
    );
    const handleFuelTypeChange = (fuel: string) => {
      sampleAnalytics(
        "action",
        "tap_btn",
        "tap_btn_fuel_type_filter_select_variant_modal",
        { selected_filter: fuel }
      );
      setFuelType(fuel);
    };

    const renderFuelType = availableFuelTypes?.map((fuel) => {
      return (
        <FuelTypeItem
          onClick={(e: any) => handleFuelTypeChange(fuel)}
          selected={fuel === fuelType}
          key={fuel}
        >
          {capitalizeFirstLetter(fuel)}
        </FuelTypeItem>
      );
    });

    const renderVariants = varianttoRender(
      fuelType || availableFuelTypes[0]
    )?.map((variant: any | undefined) => {
      const { variant_name, variant_id } = variant;
      const { variant_name: selectedVariantName } =
        selectedState?.currentStateForVariant;
      return (
        <React.Fragment key={variant.id}>
          <ModelWrapper>
            <ModelContainer
              onClick={(e: any) => handleModalClick(fuelType, variant)}
            >
              <Flex
                flexDirection="row"
                styles={{ position: "relative", alignItems: "center" }}
              >
                <ModelTextContainer
                  selected={selectedVariantName === variant_name}
                  id={variant_id}
                >
                  {variant_name}
                </ModelTextContainer>
                <RadioIconContainer>
                  <ImageContainer
                    imgSrc={resolvePath("/images/icons/chevron-down.svg")}
                    styles={{ rotate: "-90deg" }}
                    width={24}
                    height={24}
                    alt="go-ahead"
                  />
                </RadioIconContainer>
              </Flex>
            </ModelContainer>
          </ModelWrapper>
          {/* <Seperator /> */}
        </React.Fragment>
      );
    });
    const formattedText = !isDesktop
      ? "Select your car’s fuel type to <br/> see variants"
      : "Select your car’s fuel type to see variants";
    return (
      <>
        <Flex flexDirection="column" style={{ gap: "16px" }}>
          <FuelTypeContainer>{renderFuelType}</FuelTypeContainer>
          {fuelType ? (
            <>
              <ScrollBox>
                <Flex flexDirection="column">{renderVariants}</Flex>
                <VariantNotFound
                  handleModalClick={handleNotFoundClick}
                  styles={{ marginTop: "1rem" }}
                />
              </ScrollBox>
            </>
          ) : (
            <Flex flexDirection="column" style={{ height: "60vh" }}>
              <ArrowSvg style={{ position: "relative", left: " 24px" }} />
              <FuelTypeText
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(formattedText)
                }}
              />
            </Flex>
          )}
        </Flex>
      </>
    );
  };

  const getRegjsx = () => {
    // just a hack to control options modal skipping from registration year month selector
    const cb = (registrationYear: string, registrationMonth: string = "") => {
      handleModalClick(registrationYear, registrationMonth);
    };

    return (
      <>
        <YearMonthSelector
          showModal={true}
          setShowModal={setShowRegistrationYearModal}
          activeYear={selectedState?.currentStateForRegYear}
          setActiveYear={() => { }}
          activeMonth={selectedState?.currentActiveMonth}
          setActiveMonth={() => { }}
          callbackFunction={cb}
        />
      </>
    );
  };

  const getIsExternalCngKitInstalledJsx = () => {
    return (
      <MmvInfoContent
        infoText={
          "We want to ensure that it is included in your insurance coverage"
        }
        shouldShowOptions={true}
        handleModalClick={handleModalClick}
        query={query}
        firedOnce={false}
      />
    );
  };

  const getIsCommercialJsx = () => {
    return (
      <MmvInfoContent
        infoText={"For example, as a taxi or for delivering goods"}
        shouldShowOptions={true}
        handleModalClick={handleModalClick}
        query={query}
        firedOnce={false}
      />
    );
  };

  const dispatch = useDispatch();

  const handleModalClick = (selectedValue: any, optionalType = "") => {
    dispatch(
      setPayloadData({
        [query]: selectedValue
      })
    );

    // setAnalytics({
    //   [query]: selectedValue,
    // });

    setSelectedState(selectedValue, optionalType);
    if (isOptional && selectedState) {
      setShowModal(false);
      return;
    }
    // moving to next step
    if (currentModalIndex + 1 >= config?.length) {
      setShowModal(false);
      return;
    } else {
      setInput((prevInput) => "");
      setCurrentModalIndex(currentModalIndex + 1);
    }
  };

  useEffect(() => {
    // logic so that user does't skip step (i.e select variant before make)
    if (
      currentModal &&
      currentModal?.isOptional &&
      ((typeof selectedState === "string" && selectedState) ||
        typeof selectedState === "boolean" ||
        (typeof selectedState === "object" && !isObjectEmpty(selectedState)))
    ) {
      setShowModal(false);
      return;
    }
    const initalModalIndex = getInitialConfigStepIndex(config, currentId);
    const initialQuery = config?.[initalModalIndex]?.query;
    if (handleBackClickedRef.current || selectedState) {
      setCurrentModalIndex(currentModalIndex);
    } else {
      setCurrentModalIndex(initalModalIndex);
    }
    // if (initalModalIndex !== currentModalIndex) {
    //   query = initialQuery;
    // }
    const getRenderedModal = () => {
      switch (query) {
        case "make":
          return getMakeJsx();
        case "model":
          return getMakeModelJsx();
        case "variant":
        case "fuel_type":
          return getVariantsJsx();
        case "registration_year":
          return getRegjsx();
        default:
          if (query === "is_commercial" && !hideCommercialField) {
            return getIsCommercialJsx();
          }
          return null;
      }
    };

    const modalToRender = getRenderedModal();
    // closing modal when nothing to render
    if (modalToRender === null) setShowModal(false);
    setCurrentRenderedModal(modalToRender);
  }, [currentModalIndex, query, fuelType, currentModalData]);

  const getHeading = () => {
    return (
      <Flex flexDirection="row" alignItems="flex-start" style={{ gap: "1rem" }}>
        {(currentModalIndex !== 0 && currentId !== currentModalIndex) && (
          <div style={{ paddingTop: "2px" }}>
            <ChevronRight
              style={{
                transform: "rotate(90deg)",
                cursor: "pointer"
              }}
              onClick={goBack}
            />
          </div>
        )}
        <HighlightedHeading title={title} />
      </Flex>
    );
  };

  console.log("scroll currentId", query);

  // TODO: REMOVE THIS HACKY SOLUTION :(
  // useEffect(() => {
  //   if (showModal || currentId === 0 ) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "";
  //   }
  //   return () => {
  //     document.body.style.overflow = "";
  //   }
  // }, );

  const removeMaxHeight = [
    "registration_year",
    "is_commercial"
  ].includes(query);

  return (
    <>
      {!showMmvNotFoundModal && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          modalName={"MmvOptionsModal"}
          modalHeading={getHeading()}
          hideCloseButton={currentId !== currentModalIndex}
          modalHeadingStyles={{
            color: "#040222",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "28px",
            letterSpacing: "-0.1px",
            textAlign: "left",
            paddingBottom: !isDesktop ? "16px" : "0"
          }}
          bodyMargin="0px"
          isDesktop={isDesktop}
          styles={{
            maxHeight: !isDesktop ? "95%" : "520px",
            minWidth: isDesktop && "504px",
            minHeight: isDesktop && !removeMaxHeight && "504px",
            overflow: "hidden !important"
          }}
          disableOverlayClose
        >
          {currentModalData || isOptional ? (
            <Flex
              flexDirection="column"
              style={{ gap: "24px", marginTop: isDesktop ? "24px" : "0" }}
            >
              {showSearchInput && (
                <InputSearch
                  isDesktop={isDesktop}
                  placeholder={searchInputPlaceholder}
                  searchInput={input}
                  setSearchInput={setInput}
                  query={query}
                  searchCallback={() => handleSegmentCallback(query)}
                />
              )}

              {!showNoResult ? (
                <div key={currentModalData}>{currentRenderedModal}</div>
              ) : (
                <NotFound
                  handleClick={handleNotFoundClick}
                  showNoResult={showNoResult}
                  query={query}
                  input={input}
                />
              )}
            </Flex>
          ) : (
            <div>
              <SkeletonCard />
            </div>
          )}
        </Modal>
      )}
      <MmvNotFoundModal
        showModal={showMmvNotFoundModal}
        setShowModal={handleSubmitNotFoundVehicle}
        isDesktop={isDesktop}
        mmvReportQuery={query}
        sampleVariantOfSelectedModal={
          query === "variant" && getFirstVariantName(currentModalData)
        }
      />
    </>
  );
};

export default MmvOptionsModal;
